// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2Zukg","paramInput":"JobSimulator_paramInput__2Oc2k","input":"JobSimulator_input__VSXB5"};